<template>
	<div class="">
		<div  class="col-sm-12 col-md-12  col-lg-12  float-left">
			<SentimentTrend title="" subText="" modal="20"  zoom_start="70" :chart_heigh="chartHeight"></SentimentTrend>
		</div>
		<div class="clearfix"></div>
		<div class="row mb-2 flex-row justify-content-center align-items-center">
			<div class="col-sm-3">
				<div class="d-flex align-items-center">
					<b-input-group size="sm" prepend="图高(px)" class="mr-2">
						<b-form-input type="number" v-model.number="chartHeightValue" min="300" max="1200" step="10"></b-form-input>
					</b-input-group>
					<b-button-group size="sm">
						<b-button variant="outline-secondary" @click="setHeight(350)">350</b-button>
						<b-button variant="outline-secondary" @click="setHeight(420)">420</b-button>
						<b-button variant="outline-secondary" @click="setHeight(550)">550</b-button>
						<b-button variant="outline-secondary" @click="setHeight(700)">700</b-button>
					</b-button-group>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SentimentTrend from 'components/sentiment/SentimentTrend.vue'
	
	export default {
		data() {
			return {
				chartHeightValue: 350,
				chartHeightKey: 'sentiment.hot2.chartHeight'
			}
		},
		components: {
			SentimentTrend,
			
		},
		methods: {
			setHeight(val){
				this.chartHeightValue = val
			}
		}
		,computed:{
			chartHeight(){
				return `${this.chartHeightValue}px`
			}
		}
		,watch:{
			chartHeightValue(val){
				try{ localStorage.setItem(this.chartHeightKey, String(val)); }catch(e){ this.chartHeightKey = this.chartHeightKey || '' }
			}
		}
		,mounted(){
			try{
				const v = localStorage.getItem(this.chartHeightKey);
				if(v){ const n = parseInt(v,10); if(!isNaN(n) && n>=300 && n<=1200){ this.chartHeightValue = n; } }
			}catch(e){ this.chartHeightKey = this.chartHeightKey || '' }
		}
	}
</script>

<style scoped>
.mb-2 { margin-bottom: 1rem; }
</style>
